import React, { useContext, useEffect, useCallback, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { BreadCrumbs, Crumbs, ActiveCrumbs } from "components/Breadcrumbs";
import Confirm from "components/Confirm";
import Loading from "components/Loading";
import { UserContext } from "context/user";
import { getFarm, deleteCollaborator } from "api/Farm";
import "./index.scss";
import ShareFarm from "components/Modal/ShareFarm/";
import RenameFarm from "components/Modal/RenameFarm";
import FieldListContainer from "./FieldListContainer";
import CollaboratorsContainer from "./CollaboratorsContainer";

const FarmsIndexContainer = () => {
  const { token } = useContext(UserContext);
  const [farm, setFarm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpenShareModal, setIsOpenShareModal] = useState(false);
  const [farmId, setFarmId] = useState("");
  const [renameFarm, setRenameFarm] = useState(false);

  const fetchData = useCallback(async () => {
    if (!token) return;

    setLoading(true);
    const currentPath = window.location.pathname.split("/");
    let farmID = "";

    if (currentPath[1] === "farms" && currentPath[3] === "details") {
      const farmIdx = 2;
      farmID = currentPath[farmIdx];
      setFarmId(farmID);
    }
    const farmData = await getFarm(farmID, token);
    setFarm(farmData);
    setLoading(false);
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <div data-testid="loading" className="main-loader">
        <Loading uniqueKey="farms-and-fields" />
      </div>
    );
  }

  const handleShareFarmModal = () => {
    setIsOpenShareModal(true);
  };

  const removeCollaborator = async (data) => {
    const values = {
      farmId: farm?.properties?.farm_id,
      email: data.email,
    };
    try {
      const res = await deleteCollaborator(values, token);
      toast.success(res?.data?.message);
      const farmData = await getFarm(farmId, token);
      setFarm(farmData);
    } catch (err) {
      toast.error(err.response.data.detail.message);
    }
  };

  const handleDeleteModal = async (data) => {
    const options = {
      title: "Are you sure?",
      message: "You cannot undo this action",
      buttons: [
        {
          label: "Yes, delete anyway.",
          onClick: () => {
            removeCollaborator(data);
          },
          className: "-danger",
          name: "delete-collab",
        },
        {
          label: "No",
          onClick: () => {},
          className: "",
        },
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, buttons, onClose }) => (
        <Confirm
          data-testid="confirm-delete"
          title={title}
          message={message}
          buttons={buttons}
          onClose={onClose}
        />
      ),
      closeOnEscape: false,
      closeOnClickOutside: false,
      overlayClassName: "overlay-custom-class-name",
    };

    confirmAlert(options);
  };

  return (
    <div className="index-wrapper">
      <div className="top-section">
        <BreadCrumbs>
          <Crumbs text="Go Back" to="/farms" />
          <Crumbs text="Farms & Fields" to="/farms" />
          <ActiveCrumbs text={farm?.properties?.farm_name} />
        </BreadCrumbs>
        <h1 className="farm-name">
          {farm?.properties?.farm_name}
          <span
            data-tip="Rename Farm"
            className="icon-edit"
            aria-hidden
            onClick={() => setRenameFarm(true)}
          />
        </h1>
        <h4 className="general-location">
          <span className="icon-location" />
          {farm?.properties?.location || "N/A"}
        </h4>
        <Tabs className="tab-wrapper">
          <TabList className="tab-list">
            <Tab className="tab-header" selectedClassName="-active">
              Field List
            </Tab>
            {/* For Later Implementation
            <Tab className="tab-header" selectedClassName="-active">
              Order History
            </Tab> */}
            <Tab className="tab-header" selectedClassName="-active">
              Collaborators
            </Tab>
          </TabList>

          <TabPanel className="tab-panel" selectedClassName="-active">
            <FieldListContainer farm={farm} />
          </TabPanel>
          {/* For Later Implementation
          <TabPanel className="tab-panel" selectedClassName="-active">
            <OrderHistoryContainer farm={farm} />
          </TabPanel> */}
          <TabPanel className="tab-panel" selectedClassName="-active">
            <CollaboratorsContainer
              farm={farm}
              handleShareFarm={handleShareFarmModal}
              handleDeleteModal={handleDeleteModal}
            />
          </TabPanel>
        </Tabs>
      </div>
      {farm && (
        <ShareFarm
          isOpen={isOpenShareModal}
          onClose={() => setIsOpenShareModal(false)}
          selectedFarms={0}
          farm={farm.properties}
          view="farms"
        />
      )}
      {farm && (
        <RenameFarm
          farmInfo={farm.properties}
          isOpen={renameFarm}
          onClose={() => setRenameFarm(false)}
        />
      )}
    </div>
  );
};

export default FarmsIndexContainer;
